<div class="table-container">
  <ng-container *ngIf="visibleRecords().length === 0">
    <p class="d-block w-100 my-3 text-center mx-auto">There is no verified sales data for this registration.</p>
  </ng-container>
  <table *ngIf="visibleRecords().length > 0">
    <tr>
      <th>Sale Type</th>
      <th style="text-align: right">Price</th>
    </tr>
    <ng-container *ngFor="let row of visibleRecords(); let i = index">
      <tr *ngIf="row.saleType != 4"
        data-bs-toggle="tooltip"
        [attr.data-bs-placement]="tooltipPos()"
        title="Inflated Value: {{
          row.inf_sold_price / 100 | currency : 'GBP'
        }}"
      >
        <td>
          <span>{{ saleTypeMapper(row, row.saleType) }} </span>
          <span>{{ row.sold_date | date : "MMM YYYY" }}</span>
        </td>
        <td style="text-align: right">
          {{ row.sold_price / 100 | currency : "GBP" }}
        </td>
      </tr>
    </ng-container>
  </table>
</div>

<!-- sold dvla auction april 2005 -->
